<po-page-default p-title="Empresa Sócios - Domínio" [p-breadcrumb]="breadcrumb"
  p-subtitle="Gere o relatório de quadro societário com base nas informações da base de dados do sistema Domínio.">

  <!-- Resumo da página -->
  <div class="page-summary">
    <div class="page-summary-icon">
      <i class="an an-users-three"></i>
    </div>
    <div class="page-summary-text">
      <p class="po-font-subtitle po-mb-0">Relatório de Quadro Societário</p>
      <p class="page-summary-hint">
        Selecione uma empresa, envie uma planilha com os códigos ou gere para todas. O relatório será enviado por e-mail.
      </p>
    </div>
  </div>

  <po-divider></po-divider>

  <form #form="ngForm" (ngSubmit)="requestRelatorio(form)">

    <!-- Seção: Configurações -->
    <div class="es-section po-mt-3">
      <div class="es-section-header">
        <i class="an an-gear-six"></i>
        <span>Configurações do Relatório</span>
      </div>
      <div class="es-section-body">
        <div class="es-destaque po-mb-3">
          <p class="po-mb-1"><b>Uma empresa:</b> selecione no campo abaixo (consulta individual).</p>
          <p class="po-mb-1">
            <b>Várias empresas:</b> envie planilha CSV, XLSX ou XLS com os códigos.
            <a href="/assets/modelo/Modelo.xlsx" download="Modelo.xlsx" class="es-link-modelo">Baixe o modelo</a>
          </p>
          <p class="po-mb-1"><b>Todas as empresas:</b> apenas deixe o campo de empresa vazio.</p>
        </div>

        <div class="po-row">
          <app-empresa-combo
            class="po-lg-5 po-md-6 po-sm-12"
            name="empresaId"
            [(ngModel)]="empresaId"
            (ngModelChange)="onEmpresaChange()"
            label="Empresa (opcional)"
            [required]="false"
            [disabled]="!!arquivoPlanilha"
            placeholder="Buscar por código ou nome da empresa..."
            help="Ignorado quando houver planilha selecionada.">
          </app-empresa-combo>

          <div class="po-lg-5 po-md-6 po-sm-12 planilha-col">
            <label class="po-field-title">Planilha de empresas (CSV/XLSX/XLS)</label>
            <div
              class="dropzone"
              [class.dropzone-disabled]="!!empresaId"
              (drop)="onDropArquivo($event)"
              (dragover)="onDragOverArquivo($event)">
              Arraste o arquivo aqui ou
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                [disabled]="!!empresaId"
                (change)="onArquivoSelecionado($event)" />
            </div>
            <p class="po-font-text arquivo-info" *ngIf="arquivoNome">
              Arquivo: <b>{{ arquivoNome }}</b>
              <a class="es-link-limpar" (click)="limparArquivo()">Limpar</a>
            </p>
          </div>
        </div>

        <div class="es-action-row po-mt-3">
          <po-button p-label="Gerar Relatório" p-icon="an an-paper-plane-tilt"
            (p-click)="requestRelatorio(form)" [p-loading]="isLoading">
          </po-button>
        </div>
      </div>
    </div>

    <!-- Seção: Como funciona -->
    <div class="es-section po-mt-3">
      <div class="es-section-header">
        <i class="an an-info"></i>
        <span>Como funciona</span>
      </div>
      <div class="es-section-body">
        <div class="es-info-steps">
          <div class="es-info-step">
            <div class="es-step-number">1</div>
            <div class="es-step-content">
              <p class="es-step-title">Defina as empresas</p>
              <p class="es-step-desc">
                Escolha uma empresa no combo, envie uma planilha com vários códigos.
              </p>
            </div>
          </div>
          <div class="es-info-step">
            <div class="es-step-number">2</div>
            <div class="es-step-content">
              <p class="es-step-title">Processamento automático</p>
              <p class="es-step-desc">O sistema utilizará as informações do banco de dados do Domínio para gerar a planilha de Empresa Sócios.</p>
            </div>
          </div>
          <div class="es-info-step">
            <div class="es-step-number">3</div>
            <div class="es-step-content">
              <p class="es-step-title">Receba por e-mail</p>
              <p class="es-step-desc">Após o processamento, a planilha será enviada para o e-mail cadastrado em seu usuário. O processo pode levar alguns minutos.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</po-page-default>
